import React from 'react';
import PropTypes from 'prop-types';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';

const styles = (theme) => ({
  root: {
    width: '100%',
    margin: 'auto',
    display: 'flex',
    maxWidth: '700px',
    flexDirection: 'column',
    marginBottom: theme.spacing(10),
    padding: theme.spacing(2),
  },
  fields: {},
  informationContainer: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  keyValuePair: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(3),
  },
});

function Layout({
  classes,
}) {
  const {
    resource,
  } = useMetaLayoutContext();


  const valuePair = (attr, color = 'mediumGray') => {
    if (resource?.meta().field(attr)?.attr('hidden')) {
      return null;
    }
    return (
      <div className={classes.keyValuePair}>
        <Text variant={'h4'} color={'mediumGray'} text={`${resource?.meta().field(attr)?.attr('prompt')}:`} />
        <Text weight={'bold'} variant={'h4'} color={color} text={resource?.attr(attr)} />
      </div>
    );
  };
  const showClientsTimeHorizon = !resource?.meta().field('primaryClientRetirementTimeHorizon').attr('hidden');

  return (
    <div className={classes.root}>
      {resource?.attr('title')
        ? <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} /> : null}

      <MetaField attr={'primaryOwner'} />
      <MetaField attr={'secondaryOwner'} />
      <MetaField attr={'dependentOwner'} />
      <MetaField attr={'investmentObjective'} />
      {showClientsTimeHorizon && (
      <div className={classes.informationContainer}>
        {valuePair('primaryClientRetirementTimeHorizon')}
        {valuePair('secondaryClientRetirementTimeHorizon')}
      </div>
      )}

      <MetaField attr={'timeHorizon'} />
    </div>
  );
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);
